import {createSelector} from "reselect";
import {getOrpyxUsersState} from "../../store/orpyx-users-store-selectors";

export const getOrpyxUsersCreateModalState = createSelector(getOrpyxUsersState, state => state.create);
export const getOrpyxUsersCreateModalError = createSelector(getOrpyxUsersCreateModalState, state => state.error);
export const getOrpyxUsersCreateModalUser = createSelector(getOrpyxUsersCreateModalState, state => state.createdUser);

export const isOrpyxUsersCreateProcess = createSelector(getOrpyxUsersCreateModalState, state => state.inProcess);
export const isOrpyxUsersCreateModalActive = createSelector(getOrpyxUsersCreateModalState, state => state.toggle);
